import STATES from '@/utils/states';

export default function useLoadingStates() {
  return {
    LOADING_STATES: STATES
  }
}